export default () => ({
  glue: {
    page: null,
    contentManager: null,
  },
  ssr: {
    asyncData: null,
  },
})
